import React from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider, CssBaseline, createTheme } from "@mui/material";
import App from "./App";
import "./index.css";

if (process.env.NODE_ENV === "development") {
  window.pyself = {
    cache: {},

    save(key, data) {
      this.cache[key] = data;
      console.log(`[pyself] Saved: ${key}`, data);
    },

    get(key) {
      return this.cache[key];
    },

    list() {
      return Object.keys(this.cache);
    }
  };

  console.log("%cpyself debug initialized", "color: #4ade80; font-weight: bold;");
}

// Optional: create a custom theme
const theme = createTheme({
  palette: {
    mode: "dark", // or 'light'
    primary: {
      main: "#3b82f6", // blue
    },
    secondary: {
      main: "#b54b7e", // pinkish
    },
  },
  typography: {
    fontFamily: "Inter, Arial, sans-serif",
  },
});

const root = createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline /> {/* Normalizes CSS & applies theme background */}
    <App />
  </ThemeProvider>
);
